import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/utils/cn';

/**
 * MetaTag — the leading-icon + label meta row item (Figma "Home" node 1:23: "About 15 minutes",
 * "Your work stays saved on this device"). fs-* native: pill shape, fs-label-md, fs-text-subtle.
 */
export function MetaTag(t0) {
  const $ = _c(8);
  const {
    children,
    icon: Icon,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("inline-flex items-center gap-fs-sm rounded-fs-pill px-fs-sm py-fs-xxs text-fs-label-md text-fs-text-subtle", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== Icon) {
    t2 = Icon ? <Icon className="h-4 w-4" strokeWidth={1.75} /> : null;
    $[2] = Icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t1 || $[6] !== t2) {
    t3 = <span className={t1}>{t2}{children}</span>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}